const en = {
  'ATX CMS': 'NPC CONNECT',
  "auth": {
    "register": "REGISTER",
    "message": {
      "auth/invalid": "Please check email address",
      "auth/user-disabled": "Sorry this user is disabled",
      "auth/user-not-found": "No user found :(",
      "auth/wrong-password":
        "There was an issue with your password.  You can reset or try again.",
      "success": "Logged In! You will now be redirected to main page.",
    },
  },
  "Ok": "Ok",
  "Cancel": "Cancel",
  "Edit": "Edit",
  "Edit Game": "Edit",
  "Remove Game": "Remove Game",
  "Add Game": "Add Game",
  "Add Event": "Add Event",
  "Games Calendar": "Games Calendar",
  "Games Calendar - Add Event": "Games Calendar - Add Event",
  "Event Name": "Event Name",
  "Start Date": "Start Date",
  "End Date": "End Date",
  "Event Colour": "Event Colour",
  "Event Description": "Event Description",
  "All Day Event": "All Day Event",
  "Games Calendar - Edit Event": "Games Calendar - Edit Event",
  "About the Games": "About the Games",
};

export default en